(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-avis"] && !Shopify.designMode) return;
  try {
    
  class TestimonialCarousel {
    constructor(root) {
      this.list = root.querySelector('.testimonial__list--carousel');
      if (!this.list) return;
      this.prev = root.querySelector('.testimonial__arrow--prev');
      this.next = root.querySelector('.testimonial__arrow--next');
      this.prev?.addEventListener('click', () => this.scrollBy(-1));
      this.next?.addEventListener('click', () => this.scrollBy(1));
      this.list.addEventListener('scroll', () => this.update(), { passive: true });
      this.update();
    }

    scrollBy(direction) {
      const card = this.list.querySelector('.testimonial__card');
      if (!card) return;
      const step = card.getBoundingClientRect().width + 16;
      this.list.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    update() {
      const max = this.list.scrollWidth - this.list.clientWidth;
      if (this.prev) this.prev.hidden = this.list.scrollLeft <= 1;
      if (this.next) this.next.hidden = this.list.scrollLeft >= max - 1;
    }
  }

  document.querySelectorAll('.testimonial__viewport').forEach((el) => new TestimonialCarousel(el));
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.testimonial__viewport').forEach((el) => new TestimonialCarousel(el));
  });

  } catch(e) { console.error(e); }
})();
})();
